import React from 'react';
import EditCourseProvider from '../../../features/GMPCourseProvider/component/EditCourseProvider';

const EditGMPCourse = () =>
{
    return (
        <div>
            <EditCourseProvider />
        </div>
    );
};

export default EditGMPCourse;
